interface ISearchQuery {
  searchAnd?: any;
  searchOr?: any;
}

const parseURL = (params, delimmiter=',') => {
	let str = '';
  let count = 0;
  for (let key in params) {
      let value = params[key];
      if (value && typeof value === 'object') {
        if (parseURL(value)) {
          str += count ? '&' : '';
          str += `${key}=${parseURL(value)}`;
        }
        count++;
      } else if (value) {
        if (str != '') {
          str += delimmiter;
        }
      	str += `${key}==${value}`;
      }
  }
  str = str[0] === '&' ? str.substring(1) : str;
  
  return str;
}

/**
 * Parse Object Query to url string queries.
 * @param searchQuery Object
 * ie: {
 *    searchAnd: {
 *      id:1,
 *      name: 'ABC'
 *    },
 *    searchOr: {
 *      email: 'abc@mail.com'
 *      name: 'abc'
 *    }
 * }
 * @returns string
 */
export function buildURLQueryOpts(searchQuery: [ISearchQuery, string], delimmiter = ',') {
  if (typeof searchQuery === 'string' && searchQuery) {
    return searchQuery;
  }
  if (searchQuery) {
    const searchString = parseURL(searchQuery, delimmiter);
    return searchString;
  }
  return '';
}

/**
 * Construct JSON object for search query on selected enitoty.
 * @param activeEntity 
 * @param params 
 * @returns 
 */
export function generateSearchAndQuery(activeEntity: any, params?: any) {
  const searchQuery = {};
  const searchAnd = {};
  if (activeEntity) {
    const { type } = activeEntity;
    if (type.toUpperCase() === 'COMPANY') {
      const companyId = params?.companyQueryId || 'shop_company_id'
      searchAnd[companyId] = activeEntity?.id;
    } else {
      const shopId = params?.shopQueryId || 'shop_id'
      searchAnd[shopId] = activeEntity?.id;
    }
  }
  
  if (params?.companyQueryId || params?.shopQueryId) {
    params['companyQueryId'] = null;
    params['companyQueryId'] = null;
    const { companyQueryId, shopQueryId, ...newParams } = params;
    params = newParams;
  }
  searchQuery['searchAnd'] = { ...searchAnd, ...params };

  return searchQuery;
}

/**
 * Construct JSON object for table search
 * @param searchStr
 * @param fields 
 * @returns searchQuery[object]
 */
export function generateSearchOrQuery(searchStr: string, fields?: string[]) {
  if (!searchStr || !fields.length) return;

  const searchQuery = {};
  const searchOr = {};

  fields.forEach((key) => {
    searchOr[key] = searchStr;
  });
  searchQuery['searchOr'] = { ...searchOr }
  return searchQuery;
}

